export default date => {
  const monthNames = [
    'January', 'February', 'March',
    'April', 'May', 'June', 'July',
    'August', 'September', 'October',
    'November', 'December',
  ];

  const day = date.getDate();
  const monthIndex = date.getMonth();
  const hours = date.getHours();

  if (hours === 0) {
    return `${day} ${monthNames[monthIndex]}`;
  }

  const time = hours >= 13 ? `${hours - 12}pm` : `${hours}am`;
  return `${day} ${monthNames[monthIndex]}, ${time}`;
};
